import Banner from "../components/LandingPage/banner";
import MainSection from "../components/LandingPage/mainSecction";
import Navigation from "../components/LandingPage/navigation/index";
import Testimonial from "../components/LandingPage/testimonial";
import styles from "../styles/main.module.scss";
import MapSection from "../components/LandingPage/mapSection/mapSection";
import GetSection from "../components/LandingPage/GetSection/GetSection";
import Footer from "../components/LandingPage/Footer/Footer";
import Nav from "../components/common/sidebarWrapper/navigationSideBar/index";

export default function Home() {
  return (
    <>
      <div className={styles.background}>
        <Nav backgroundMain={true}/>
        <Navigation />
        <Banner />
        <MainSection />
        <Testimonial />
        <MapSection />
        <GetSection />
        <Footer />
      </div>
    </>
  );
}
